import { createContext, useContext, useEffect, useState } from 'react';
import { fetchStaticJson } from '../utils/utils';

const DataContext = createContext({
    activities: [],
    services: [],
    projects: [],
    stats: [],
    footerSocial: [],
    nav: [],
    videos: [],
});

export const DataProvider = ({ children }) => {
    const [data, setData] = useState({ activities: [], services: [], projects: [], stats: [], footerSocial: [], nav: [], videos: [], });

    useEffect(() => {
        const files = {
            activities: window.config.activitiesFile,
            services: window.config.servicesFile,
            projects: window.config.projectsFile,
            stats: window.config.statsFile,
            footerSocial: window.config.footerSocialFile,
            nav: window.config.navFile,
            videos: window.config.videosFile,
        };
        Object.entries(files).forEach(([key, url]) => {
            fetchStaticJson(url)
                .then((res) => setData((prev) => ({ ...prev, [key]: res })))
                .catch(() => { });
        });
    }, []);

    return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
};

export const useData = () => useContext(DataContext);
